module.exports = __webpack_public_path__ + "img/team-1-7.4286c051.jpeg";